import { Loader2 } from "lucide-react";
import { AdminSurveysView } from "@/components/surveys/admin-surveys-view";
import { ManagerSurveysView } from "@/components/surveys/manager-surveys-view";
import { useAuth } from "@/hooks/use-auth";
import { useSurveyAccess } from "@/hooks/use-survey-access";

export default function Surveys() {
  const { isManager, isLoading } = useAuth();
  const { canOperateSurveys } = useSurveyAccess();

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (canOperateSurveys) {
    return <AdminSurveysView />;
  }

  if (isManager) {
    return <ManagerSurveysView />;
  }

  return (
    <div className="flex-1 flex items-center justify-center">
      <p className="text-muted-foreground">Acesso não autorizado</p>
    </div>
  );
}
